<template>
  <div class="bg-white text-gray-900 max-h-screen">
<div class="flex flex-col md:flex-row h-screen mx-auto border border-gray-200 overflow-hidden min-h-0">
      <!-- Left Sidebar -->
     <aside 
  v-if="!activeConversation || !activeConversation._id" 
  class="w-full  md:w-80 border-b md:border-b-0 md:border-r border-gray-200 flex flex-col"
>
  <header class="flex items-center justify-between px-6 py-4 border-b border-gray-200">
    <h2 class="text-lg font-semibold text-gray-900 h-[40px]">Messages</h2>

  </header>


  <nav class="flex-1 overflow-y-auto divide-y divide-gray-100">
<!-- Mode nouveau message : liste des clients -->
<template v-if="newMessageMode">
  <a
    v-for="client in clients"
    :key="client.id"
    href="#"
    class="flex items-center gap-3 px-6 py-3 hover:bg-gray-50 bg-white"
    @click.prevent="startChat(client)"
  >
    <img :src="getAvatar(client)" :alt="client.nom + ' ' + client.prenom" class="w-10 h-10 rounded-full" />
    <div class="flex flex-col flex-1 min-w-0">
      <span class="font-semibold truncate text-gray-900">{{ client.nom }} {{ client.prenom }}</span>
    </div>
  </a>
</template>

<!-- Mode conversations récentes -->
<div v-else>
  <a
    v-for="conv in conversations"
    :key="conv._id"
    href="#"
    class="flex items-center gap-3 px-6 py-3 hover:bg-gray-50 bg-white relative"
    :class="conv.active ? 'border-l-4 border-blue-600' : ''"
    @click.prevent="startChat(conv.client)"
  >
    <div class="relative">
      <!-- Avatar client/admin -->
      <img 
        :src="conv.admin.photo || conv.entreprise.logo || getAvatar(conv.admin)"
        :alt="conv.admin.nom + ' ' + conv.admin.prenom"
        class="w-10 h-10 rounded-full"
      />

      <!-- Point rouge pour messages non lus -->
      <span
        v-if="conv.messages.length && !conv.messages[conv.messages.length - 1].read && conv.messages[conv.messages.length - 1].sender !== 'You'"
        class="absolute bottom-0 right-0 w-3 h-3 bg-red-500 border-2 border-white rounded-full"
      ></span>
    </div>

    <div class="flex flex-col flex-1 min-w-0">
      <span
        class="truncate"
        :class="{'font-semibold text-gray-900': conv.messages.length && !conv.messages[conv.messages.length - 1].read && conv.messages[conv.messages.length - 1].sender !== 'You', 'text-gray-900': true}"
      >
        {{ conv.admin.nom }} {{ conv.admin.prenom }}
      </span>

      <span
        class="text-xs truncate"
        :class="{'font-semibold text-gray-800': conv.messages.length && !conv.messages[conv.messages.length - 1].read && conv.messages[conv.messages.length - 1].sender !== 'You', 'text-gray-400': true}"
      >
        {{ conv.messages[conv.messages.length - 1]?.text || 'Aucun message' }}
      </span>
    </div>

    <div class="flex flex-col">
      <span class="ml-auto text-xs text-gray-400 font-semibold select-none">
        {{ conv.messages[conv.messages.length - 1]?.time || '' }}
      </span>
    </div>
  </a>
</div>




  </nav>
</aside>


           <!-- Main Chat Area -->
<main class="flex flex-col h-screen w-full max-w-screen">
  <template v-if="activeConversation && activeConversation._id">

    <!-- Header du chat -->
<!-- Header du chat -->
<header class="flex items-center justify-between border-b border-gray-200 px-4 sm:px-6 py-3">
  <div class="flex items-center gap-3 sm:gap-4">
    <img
      :src="activeConversation.admin.photo || activeConversation.entreprise.logo || getAvatar(activeConversation.admin)"
      :alt="activeConversation.admin.nom + ' ' + activeConversation.admin.prenom"
      class="w-10 h-10 rounded-full"
    />
    <div class="flex flex-col leading-tight">
      <span class="font-semibold text-gray-900 text-sm sm:text-base">
        {{ activeConversation.admin.nom }} {{ activeConversation.admin.prenom }}
      </span>
      <span class="text-xs sm:text-sm text-gray-500">
        {{ activeConversation.entreprise.nom }}
      </span>
    </div>
  </div>

  <!-- Bouton Clear Conversation -->
  <button
    @click="clearConversation"
    class="bg-red-500 hover:bg-red-600 text-white text-xs sm:text-sm px-3 py-1 rounded-lg"
  >
    Retour
  </button>
</header>


    <!-- Contenu du chat -->
<section 
  ref="chatContainer" 
  class="flex-1 overflow-y-auto bg-gray-100 px-4 sm:px-6 py-3 min-h-0"
>
      <div v-for="(message, index) in messages" :key="message.id" class="mb-4 sm:mb-6">

        <!-- Date centrée -->
        <template v-if="index === 0 || new Date(messages[index].createdAt).toDateString() !== new Date(messages[index - 1].createdAt).toDateString()">
          <div class="flex justify-center my-2">
            <span class="text-xs text-gray-600 bg-gray-200 rounded-full px-3 py-1 select-none">
              {{ formatDate(message.createdAt) }}
            </span>
          </div>
        </template>

        <!-- Message -->
        <div :class="[message.sender === 'You' ? 'ml-auto flex items-end gap-2 justify-end' : 'flex items-start gap-2']">
          
          <!-- Avatar client/entreprise -->
          <img
            v-if="message.sender !== 'You'"
            :src="activeConversation.entreprise.logo || getAvatar(activeConversation.client)"
            :alt="activeConversation.entreprise.nom + ' ' + activeConversation.client.prenom"
            class="w-8 h-8 sm:w-10 sm:h-10 rounded-full mt-1"
          />

          <div class="relative max-w-[70%] sm:max-w-[400px]">
            <p class="font-semibold mb-1 text-xs sm:text-sm" :class="message.color || 'text-gray-900'">
              {{ message.sender }}
            </p>
            <div
              class="rounded-xl px-4 sm:px-5 py-2 sm:py-3 text-sm leading-relaxed relative"
              :class="message.sender === 'You'
                ? 'bg-blue-600 text-white whitespace-pre-line'
                : 'bg-white text-gray-900'"
            >
              {{ message.text }}

              <!-- Double check -->
              <span
                v-if="message.sender === 'You' && message === lastYourMessage && message.read"
                class="absolute bottom-1 right-1 flex items-center gap-0.5 text-xs text-blue-400"
              >
                <span class="font-bold">✓</span>
                <span class="font-bold -ml-1">✓</span>
              </span>
            </div>

            <time class="block text-xs text-gray-400 mt-1 select-none">
              {{ message.time }}
            </time>
          </div>

          <!-- Avatar "You" -->
          <img
            v-if="message.sender === 'You'"
            :src="getAvatar({ nom: 'Dev', prenom: 'Lead' })"
            alt="You"
            class="w-8 h-8 sm:w-10 sm:h-10 rounded-full"
          />
        </div>
      </div>
    </section>

    <!-- Formulaire d'envoi -->
<form
  class="flex-shrink-0 flex items-center gap-3 border-t border-gray-200 px-4 sm:px-6 py-2 sm:py-3 bg-white fixed bottom-0 left-0 w-full z-10"
  @submit.prevent="sendMessage"
>
  <input
    v-model="newMessage"
    type="text"
    placeholder="Type a message..."
    class="flex-1 rounded-lg border border-gray-200 py-2 px-3 sm:py-2 sm:px-4 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
  />
  <button
    type="submit"
    class="bg-gray-900 text-white rounded-lg px-4 sm:px-5 py-2 flex items-center gap-2 hover:bg-gray-800"
  >
    <i class="fas fa-paper-plane"></i>
    <span class="hidden sm:inline">Send</span>
  </button>
</form>

  </template>

  <!-- Si aucune conversation active -->
  <template v-else>
    <div class="flex-1 flex flex-col items-center justify-center bg-gray-100 text-gray-400 px-4">
      <i class="far fa-comment-dots text-6xl mb-4"></i>
      <p class="text-lg font-semibold text-center">Aucune conversation active</p>
      <p class="text-sm mt-2 text-center">Sélectionnez un client pour commencer à discuter.</p>
    </div>
  </template>
</main>


    </div>
  </div>
</template>

<script>
import axios from "axios";
import { io } from "socket.io-client";

const socket = io("https://datafuseweb-95a5588f8542.herokuapp.com");

export default {
  name: "ChatUI",
  data() {
    return {
      searchQuery: "",
      newMessageMode: false,
      newMessage: "",
      clients: [],
      conversations: [],
      adminId: null, // à récupérer depuis le token ou le store
      userRole: null,
    userId: null,
    };
  },

computed: {
  activeConversation() {
    // Retourne seulement la conversation activée, sinon null
    return this.conversations.find(conv => conv.active) || null;
  },
  messages() {
    return this.activeConversation?.messages || [];
  },
  lastYourMessage() {
    return [...this.messages].reverse().find(m => m.sender === "You");
  }
},


  methods: {
      clearConversation() {
      if (this.activeConversation) {
        this.activeConversation.active = false; // désactive la conversation
      }
  },
     formatDate(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
  },
    async fetchClients() {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("https://datafuseweb-95a5588f8542.herokuapp.com/api/clients", {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.clients = res.data;
      } catch (error) {
        console.error("Erreur lors de la récupération des clients :", error);
      }
    },

async fetchConversations() {
  try {
    const token = localStorage.getItem("token");
    const { data } = await axios.get(
      "https://datafuseweb-95a5588f8542.herokuapp.com/api/messages/conversations",
      { headers: { Authorization: `Bearer ${token}` } }
    );

    this.conversations = data.map((conv) => {
      const entreprise = conv.admin?.entreprise || {};
      const client = conv.client || { nom: "Inconnu", prenom: "", avatar: "" };
      const admin = conv.admin || { nom: "Inconnu", prenom: "", avatar: "" };
      this.userRole = conv.userRole
      return {
        _id: conv._id,
        client,
        admin,
        entreprise,
        
        messages: conv.lastMessage
          ? [
              {
                id: conv.lastMessage._id,
                sender: conv.lastMessage.senderRole === conv.userRole ? "You" : 
                        conv.userRole === "client"
                          ? `${admin.nom} ${admin.prenom}`.trim()
                          : `${client.nom} ${client.prenom}`.trim(),
                avatar: conv.lastMessage.senderRole === conv.userRole
                  ? (conv.userRole === "client"
                      ? client.logo || entreprise?.logo || "https://placehold.co/40x40/6366f1/ffffff/png?text=CL"
                      : admin.logo || "https://placehold.co/40x40/9a4a4a/ffffff/png?text=AD")
                  : (conv.userRole === "client"
                      ? admin.logo || "https://placehold.co/40x40/9a4a4a/ffffff/png?text=AD"
                      : client.logo || entreprise?.logo || "https://placehold.co/40x40/6366f1/ffffff/png?text=CL"),
                text: conv.lastMessage.message,
                time: new Date(conv.lastMessage.createdAt).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                }),
              },
            ]
          : [],
        active: false,
      };
    });

    // Trier par date du dernier message
    this.conversations.sort((a, b) => {
      const aTime = a.messages[0]?.time ? new Date(`1970-01-01T${a.messages[0].time}:00`) : 0;
      const bTime = b.messages[0]?.time ? new Date(`1970-01-01T${b.messages[0].time}:00`) : 0;
      return bTime - aTime;
    });

    console.log("Conversations chargées :", this.conversations);
    console.log(this.userRole)
  } catch (err) {
    console.error(
      "Erreur lors de la récupération des conversations :",
      err.response?.data || err.message
    );
  }
},


async loadMessages(conversation) {
  try {
    const token = localStorage.getItem("token");

    const { data } = await axios.get(
      `https://datafuseweb-95a5588f8542.herokuapp.com/api/messages/${conversation._id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const userRole = data.userRole;   // 'client' ou 'admin'

    conversation.messages = data.messages
      .map((m) => {
        const isYou = m.senderRole === userRole;

        return {
          id: m._id,
          sender: isYou ? "You" : userRole === "client"
            ? `${conversation.admin.nom} ${conversation.admin.prenom}`.trim()
            : `${conversation.client.nom} ${conversation.client.prenom}`.trim(),
          avatar: isYou
            ? (userRole === "client"
                ? conversation.client.photo || conversation.entreprise?.logo || "https://placehold.co/40x40/6366f1/ffffff/png?text=CL"
                : conversation.admin.photo || "https://placehold.co/40x40/9a4a4a/ffffff/png?text=AD")
            : (userRole === "client"
                ? conversation.admin.photo || "https://placehold.co/40x40/9a4a4a/ffffff/png?text=AD"
                : conversation.client.photo || conversation.entreprise?.logo || "https://placehold.co/40x40/6366f1/ffffff/png?text=CL"),
          text: m.message,
          time: new Date(m.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
          createdAt: m.createdAt
        };
      })
      .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  } catch (err) {
    console.error("❌ Erreur loadMessages:", err.response?.data || err.message);
  }
},

async startChat(client) {
  try {
    const token = localStorage.getItem("token");

    // Chercher si la conversation existe déjà
    let existingConv = this.conversations.find(
      (conv) => conv.client._id === client._id
    );

    if (!existingConv) {
      // Créer une nouvelle conversation seulement si elle n'existe pas
      const { data } = await axios.post(
        "https://datafuseweb-95a5588f8542.herokuapp.com/api/messages/conversation",
        { clientId: client._id, adminId: this.adminId },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      existingConv = {
        _id: data._id,
        client,
        admin: this.userRole === "admin" ? { _id: this.userId } : {}, 
        messages: [],
        active: false,
      };

      this.conversations.push(existingConv);
    }

    // Activer cette conversation et désactiver les autres
    this.conversations.forEach(
      (conv) => (conv.active = conv.client._id === client._id)
    );

    // Rejoindre la room Socket.io
    this.joinConversation(existingConv._id);

    // Charger les messages
    await this.loadMessages(existingConv);

    this.newMessageMode = false;
  } catch (err) {
    console.error("❌ Erreur startChat:", err.response?.data || err.message);
  }
},


joinConversation(conversationId) {
  socket.emit("joinConversation", conversationId);
},



async sendMessage() {
  if (!this.newMessage.trim()) return;

  const conv = this.activeConversation;
  if (!conv._id) return console.warn("⚠️ La conversation n'a pas d'ID");

  const messageData = {
    conversationId: conv._id,
    message: this.newMessage,
    type: "text",
    clientId: conv.client._id,
    adminId: conv.admin._id,
    attachments: [], // si tu veux gérer les fichiers
    senderRole : this.userRole
  };

  // Envoyer via Socket.io
  socket.emit("sendMessage", messageData);
  this.scrollToBottom(); 
  this.newMessage = "";
},

scrollToBottom() {
    this.$nextTick(() => {
      const container = this.$refs.chatContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    });
  },



getAvatar(userOrEntreprise) {
  // Si c'est un logo d'entreprise
  if (userOrEntreprise.logo) return userOrEntreprise.logo;

  // Si c'est un utilisateur avec un avatar
  if (userOrEntreprise.photo) return userOrEntreprise.photo;

  // Sinon, générer les initiales
  const fullName = `${userOrEntreprise.nom || ""} ${userOrEntreprise.prenom || userOrEntreprise.name || ""}`.trim();
  if (!fullName) return "https://placehold.co/40x40/cccccc/ffffff/png?text=?";

  const initials = fullName
    .split(" ")
    .map((n) => n[0]?.toUpperCase())
    .join("")
    .slice(0, 2);

  return `https://placehold.co/40x40/6366f1/ffffff/png?text=${initials}`;
},
markMessagesAsRead(conversation) {
  const unreadMessages = conversation.messages.filter(
    (m) => m.sender !== "You" && !m.read
  );

  if (unreadMessages.length > 0) {
    const token = localStorage.getItem("token");
    const ids = unreadMessages.map((m) => m.id);

    axios
      .put(
        "https://datafuseweb-95a5588f8542.herokuapp.com/api/messages/read",
        { messageIds: ids }, // envoie un tableau
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        unreadMessages.forEach((m) => (m.read = true));
      })
      .catch((err) => console.error("Erreur read:", err));
  }
},

handleReceiveMessage(message) {
  const conv = this.conversations.find(c => c._id === message.conversationId);
  if (!conv) return;

  const isYou = message.senderRole === this.userRole;

  conv.messages.push({
    id: message._id,
    sender: isYou ? "You" : this.userRole === "client"
      ? `${conv.admin.nom} ${conv.admin.prenom}`.trim()
      : `${conv.client.nom} ${conv.client.prenom}`.trim(),
    avatar: isYou
      ? (this.userRole === "client" ? conv.client.photo || conv.entreprise?.logo : conv.admin.photo)
      : (this.userRole === "client" ? conv.admin.photo : conv.client.photo || conv.entreprise?.logo),
    text: message.message,
    time: new Date(message.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    createdAt: message.createdAt,
    read: isYou,
  });
  this.scrollToBottom(); 

  // Marquer comme lu si conversation active
  if (!isYou && conv.active) this.markMessagesAsRead(conv);
},

  },

watch: {
  activeConversation: {
    handler(newConv) {
      if (newConv && newConv._id) {
        this.loadMessages(newConv).then(() => this.markMessagesAsRead(newConv));
      }
    },
    immediate: true,
  },
},

mounted() {
  // Récupérer userRole et userId depuis le token
  const token = localStorage.getItem("token");
  if (token) {
    const payload = JSON.parse(atob(token.split(".")[1]));
    this.userRole = payload.role; // 'admin' ou 'client'
    this.userId = payload.id;     // ID de l'utilisateur connecté
    this.adminId = this.userRole === "admin" ? this.userId : null;
  }

  this.fetchClients();
  this.fetchConversations();

  // Événement Socket.io pour recevoir les messages
  socket.on("receiveMessage", this.handleReceiveMessage);
},

};
</script>

